import style from './style.module.scss';
const MODAL_DIMENSION = {maxWidth: 320, maxHeight: 340};

const ARROWHEAD_STYLES = {
  TOP_LEFT: 'TOP_LEFT',
  TOP_RIGHT: 'TOP_RIGHT',
  BOTTOM_LEFT: 'BOTTOM_LEFT',
  BOTTOM_RIGHT: 'BOTTOM_RIGHT',
  LEFT_BOTTOM: 'LEFT_BOTTOM',
  LEFT_CENTRE: 'LEFT_CENTRE',
  RIGHT_CENTRE: 'RIGHT_CENTRE',
  RIGHT_BOTTOM: 'RIGHT_BOTTOM',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  BOTTOM: '_BOTTOM',
  CENTRE: '_CENTRE',
};

export function calculateTooltipPosition(event) {
  /**
   * This function used to calculte the Top & Left of the tooltip modalwindow
   * Calculate the position of arrowhead in tooltip modalwinodw.
   */
  const viewPortWidth = getViewportWidth();
  const viewPortHeight = getViewportHeight();
  const wordPhrase = event.target;
  const wordRect = wordPhrase.getBoundingClientRect();
  /**
   * Get the higlighted content-text,text hieght, text width
   */
  const highLightText = wordPhrase.innerText;
  const highLightTextHeight = wordPhrase.offsetHeight;
  const highLightTextWidth = wordPhrase.offsetWidth;

  /**
   * Tooltip modalwindow arrow head dimensions
   */
  const toolTipArrowHeight = 10;
  const toolTipPaddingTop = highLightTextHeight + toolTipArrowHeight;

  /**
   * Calculate Current mouse click postion (Left & Top)
   */
  let modalLeft = wordRect.left;
  let modalTop = wordRect.top;

  /**
   * Calculate rendering position of arrow head in tooltip modal window.
   * Default arrowhead positions TOP_LEFT,TOP_RIGHT,BOTTOM_LEFT,BOTTOM_RIGHT
   */
  let arrowPosition = getToolTipArrowPosition({
    viewPortWidth,
    viewPortHeight,
    modalLeft: wordRect.left,
    modalTop: wordRect.top,
  });

  /**
   * Tooltip modalwindow max height & max width
   */
  const modalWidth = MODAL_DIMENSION.maxWidth;
  const modalHeight = MODAL_DIMENSION.maxHeight;

  /**
   * Split viewport width & height
   */
  const upperMiddle = viewPortHeight * 0.25;
  const middle = viewPortHeight * 0.5;
  const centre = viewPortWidth * 0.5;

  /**
   * Set arrowhead postion
   */
  let isSetArrow = false;
  let currentArrowPosition = '';

  /**
   * Check if space to render on current viewport width & set the Left position of the Modal Window
   */
  if (modalLeft < centre) {
    /**
     * Check if space to render on the left of the window and adjust placement
     */
    modalLeft += toolTipPaddingTop;
    currentArrowPosition = ARROWHEAD_STYLES.LEFT;
  } else {
    /**
     * Check if space to render on the right of the window and adjust placement
     */
    currentArrowPosition = ARROWHEAD_STYLES.RIGHT;
    modalLeft -= modalWidth - toolTipPaddingTop;
  }

  /**
   * Check if space to render on current viewport height & set the Top position of the Modal Window
   */
  if (modalTop < upperMiddle) {
    /**
     * Check if space to render on the upper middle of the window and adjust placement
     */
    modalTop += toolTipPaddingTop;
  } else if (modalTop < middle) {
    /**
     * Check if space to render on the middle of the window and adjust placement
     * Assumes that arrow head should render on the CENTRE_LEFT/CENTRE_RIGHT of modalwindow by setting isSetArrow
     */
    isSetArrow = true;
    currentArrowPosition += ARROWHEAD_STYLES.CENTRE;
    modalTop -= modalHeight * 0.5 - toolTipPaddingTop;
  } else {
    /**
     * Check if space to render on the lower middle of the window and adjust placement
     *  Assumes that arrow head should render on the BOTTOM_LEFT/BOTTOM_RIGHT of modalwindow by setting isSetArrow
     */
    modalTop -= modalHeight - toolTipPaddingTop;
    isSetArrow = true;
    currentArrowPosition += ARROWHEAD_STYLES.BOTTOM;
  }

  if (modalTop < 0) {
    /**
     * check if space to render top and adjust placement
     */
    modalTop += -1 * modalTop;
  }
  if (
    currentArrowPosition === ARROWHEAD_STYLES.LEFT_BOTTOM ||
    currentArrowPosition === ARROWHEAD_STYLES.LEFT_CENTRE
  ) {
    /**
     * check if set left of the modal window at the end of heighlighted content
     */
    modalLeft += highLightTextWidth;
  } else if (
    currentArrowPosition === ARROWHEAD_STYLES.RIGHT_BOTTOM ||
    currentArrowPosition === ARROWHEAD_STYLES.RIGHT_CENTRE
  ) {
    /**
     * check if set left of the modal window at the end of heighlighted content
     */
    modalLeft -= highLightTextWidth;
  }

  return {
    scrollX: window.scrollX,
    scrollY: window.scrollY,
    modalTop,
    modalLeft,
    highLightText,
    highLightTextHeight,
    arrowPosition: isSetArrow ? currentArrowPosition : arrowPosition,
  };
}

function getViewportWidth() {
  return Math.max(
    document.documentElement.clientWidth ?? 0,
    window.innerWidth ?? 0
  );
}

function getViewportHeight() {
  return Math.max(
    document.documentElement.clientHeight ?? 0,
    window.innerHeight ?? 0
  );
}

export function getArrowPosition(switchCaseString) {
  /**
   * This function returns the style for arrow head in tooltip modal window
   */
  switch (switchCaseString) {
    case ARROWHEAD_STYLES.TOP_LEFT:
      return [style.top, style.allignArrowLeft];
    case ARROWHEAD_STYLES.TOP_RIGHT:
      return [style.top, style.allignArrowRight];
    case ARROWHEAD_STYLES.BOTTOM_LEFT:
      return [style.bottom, style.allignArrowLeft];
    case ARROWHEAD_STYLES.BOTTOM_RIGHT:
      return [style.bottom, style.allignArrowRight];
    case ARROWHEAD_STYLES.LEFT_BOTTOM:
      return [style.left, style.alignArrowBottom];
    case ARROWHEAD_STYLES.LEFT_CENTRE:
      return [style.left, style.alignArrowLeftCentre];
    case ARROWHEAD_STYLES.RIGHT_CENTRE:
      return [style.right, style.alignArrowRightCentre];
    case ARROWHEAD_STYLES.RIGHT_BOTTOM:
      return [style.right, style.alignArrowRightBottom];
    default:
      return [style.top, style.allignArrowLeft];
  }
}

function getToolTipArrowPosition({
  modalLeft,
  modalTop,
  viewPortWidth,
  viewPortHeight,
}) {
  /**
   * Calculate rendering position of arrow head in tooltip modal window.
   * Return corresponding string for each class :-TOP_LEFT,TOP_RIGHT,BOTTOM_LEFT,BOTTOM_RIGHT
   */
  let arrowPosition;
  const halfofViewPortWidth = viewPortWidth * 0.5;
  const halfofViewPortHeight = viewPortHeight * 0.5;
  if (modalLeft < halfofViewPortWidth && modalTop < halfofViewPortHeight) {
    arrowPosition = ARROWHEAD_STYLES.TOP_LEFT;
  } else if (
    modalLeft < halfofViewPortWidth &&
    modalTop > halfofViewPortHeight
  ) {
    arrowPosition = ARROWHEAD_STYLES.BOTTOM_LEFT;
  } else if (
    modalLeft > halfofViewPortWidth &&
    modalTop > halfofViewPortHeight
  ) {
    arrowPosition = ARROWHEAD_STYLES.BOTTOM_RIGHT;
  } else if (
    modalLeft > halfofViewPortWidth &&
    modalTop < halfofViewPortHeight
  ) {
    arrowPosition = ARROWHEAD_STYLES.TOP_RIGHT;
  }
  return arrowPosition;
}
